import { axios } from 'services/axios';

/**
 * Returns available 8x8 service providers.
 *
 * Wholesaler — GET /ServiceProviders/EightByEight (X-RequestScope: 80)
 * Partner    — GET /ServiceProfiles/EightByEight/Partner/{partnerID}/ServiceProviders/Available
 *
 * @param {{ level: string, partnerID: string }} params
 */
const getEightByEightServiceProviders = async ({ level, partnerID }) => {
    if (level === 'partner') {
        const res = await axios.get(
            `/ServiceProfiles/EightByEight/Partner/${partnerID}/ServiceProviders/Available`,
            { _requestScopeOverride: 60 },
        );
        return Array.isArray(res.data) ? res.data : [];
    }
    const res = await axios.get('/ServiceProviders/EightByEight', {
        _requestScopeOverride: 80,
    });
    return Array.isArray(res.data) ? res.data : [];
};

export default getEightByEightServiceProviders;
